import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassListView, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseClasses {
  startDate: string;
  endDate: string;
  days: string[];
  enabled?: boolean;
  startTime: string;
  kiloClassType?: string;
  location?: string | null;
  excludeRoot?: boolean;
}

function useClasses({
  startDate,
  endDate,
  days,
  enabled = true,
  startTime,
  kiloClassType,
  location,
  excludeRoot,
}: IUseClasses): UseQueryResult<{ data: Array<KiloClassListView> }> {
  const params: UrlParams = {};

  if (days.length > 0) {
    params.days = days.join(',');
  }
  params.start = startDate;
  params.end = endDate;
  params.start_time = startTime;
  if (!!kiloClassType) {
    params.kilo_class_type = kiloClassType;
  }
  if (location !== undefined) {
    params.location = location ? location : 'None';
  }
  if (excludeRoot !== undefined) {
    params.exclude_root = 'True';
  }
  return useQuery(
    ['classes', startDate, endDate, enabled, startTime, days, kiloClassType, location, excludeRoot],
    () => client.get(`kilo-classes/?${encodeUrlParams(params)}`),
    {
      enabled,
    },
  );
}

export default useClasses;
